import * as types from '../constants/actionTypes';

const initialState = {
  vendors: [],
  products: [],
  delivery_addresses: [],
  firm_names: [],
  loading: false,
  error: null
};

const homeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_HOME_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case types.FETCH_HOME_DATA_SUCCESS:
      // Store permissions if provided in home data response
      if (action.payload.permissions) {
        localStorage.setItem('permissions', JSON.stringify(action.payload.permissions));
      }
      return {
        ...state,
        loading: false,
        vendors: action.payload.vendors || [],
        products: action.payload.products || [],
        delivery_addresses: action.payload.delivery_addresses || [],
        firm_names: action.payload.firm_names || [],
        error: null
      };

    case types.FETCH_HOME_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        vendors: [],
        products: [],
        delivery_addresses: [],
        firm_names: []
      };

    default:
      return state;
  }
};

export default homeReducer;